import axios, { AxiosResponse } from "axios";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { IAddEditStop, IStop } from "../models/stop";

export const addStop = async (dto: IAddEditStop): Promise<AxiosResponse<IStop>> => {
    return await axios.post("/docks/stop", dto);
};

export const changeStop = async (dto: IAddEditStop): Promise<AxiosResponse<IStop>> => {
    return await axios.patch("/docks/stop", dto);
};

export const deleteStop = async (id: number): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/docks/stop/${id}`);
};

export const getStop = async (id: string): Promise<AxiosResponse<IStop>> => {
    return await axios.get(`/docks/stop/${id}`);
};

export const searchStops = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IStop> => {
    return await axios.post("/docks/stop/search", searchParams);
};

export const sendBookingRequest = async (stopId: number): Promise<AxiosResponse<IStop>> => {
    return await axios.post(`/docks/stop/sendBookingRequest/${stopId}`);
};

export const cancelBooking = async (
    stopId: number,
    reason: string,
): Promise<AxiosResponse<IStop>> => {
    return await axios.patch(`/docks/stop/cancelBooking/${stopId}`, { reason });
};

export const updateShipData = async (stopId: number): Promise<AxiosResponse<IStop>> => {
    return await axios.patch(`/docks/stop/updateShipData/${stopId}`);
};

export const confirmChangedBooking = async (stopId: number): Promise<AxiosResponse<IStop>> => {
    return await axios.patch(`/docks/stop/confirmChangedBooking/${stopId}`);
};
